export default new URL("../images/panel-generic.jpg", import.meta.url).href;